import { DEFAULT_LOCALE_CODE } from '../../../const';
import dayjs from 'dayjs';

export function getLocalization( locArr ) {
    const localization = locArr?.find( l => l.locale === DEFAULT_LOCALE_CODE ) ?? locArr?.[ 0 ];
    return localization?.content ?? undefined;
}

export function getDate( dt ) {
    if ( !dt ) {
        return dt;
    }
    const day = dayjs( dt );
    if ( day.isValid() ) {
        return day;
    }
    return dt;
}

export function getMeta( search ) {
    return {
        totalCount: search.totalCount,
        limit: search.searchOptions.limit,
        page: search.searchOptions.page
    };
}

export function formatGeneric( i ) {
    return {
        ...i,
        defaultDescription: i.description === null ? null : Array.isArray( i.description ) ? getLocalization( i.description ) : i.description,
        defaultName: Array.isArray( i.name ) ? getLocalization( i.name ) : i.name,
        publishedAt: getDate( i.publishedAt ),
        createdAt: getDate( i.createdAt ),
        updatedAt: getDate( i.updatedAt ),
    };
}

export function formatTranslations( locales ) {
    return locales.filter( l => l.name !== null ).sort( ( a, b ) => a.code === DEFAULT_LOCALE_CODE ? -1 : b.code === DEFAULT_LOCALE_CODE ? 1 : 0 );
}

/**
 * This is for search items with the following structure:
 * {
 *      name: [{ content, locale }],
 *      description: [{ content, locale }],
 * }
 * and outputs this easier to use structure:
 * [{name, description, code}]
 * 
 * Does not filter or sort
 * @param {*} item search item
 * @returns translations objects with zipped name + description
 */
export function zipLocales( item ) {
    return item.name.map( ( n, i ) => ( { 
        name: n.content, 
        description: item.description?.[ i ]?.content ?? '', 
        code: n.locale 
    } ) );
}

export function flatten( result ) {
    if ( [ undefined, null ].includes( result ) ) {
        return result;
    }
    if ( Array.isArray( result ) ) {
        return result.map( e => flatten( e ) );
    }
    if ( result?.edges ) {
        return result.edges.map( e => flatten( e ) );
    }
    if ( result?.node ) {
        return flatten( result.node );
    }
    if ( typeof result !== 'object' ) {
        return result;
    }
    return Object.fromEntries( Object.entries( result ).map( ( [ key, value ] ) => [ key, flatten( value ) ] ) );
}